/**
 * Created by Tomasz Gabrysiak @ Infermedica on 08/02/2017.
 */

const template = (context) => {
  return new Promise((resolve) => {
    resolve(`
      <h5 class="card-title">উপসর্গ চেকারে আপনাকে স্বাগতম</h5>
      <div class="card-text">
        <p>সংক্ষিপ্ত (3 মিনিট) আপনি নিরাপদ এবং বেনামে স্বাস্থ্য পরীক্ষা করতে চলেছেন। আপনার উত্তরগুলি সাবধানে বিশ্লেষণ করা হবে এবং আপনি আপনার লক্ষণগুলির সম্ভাব্য কারণগুলি সম্পর্কে শিখবেন।</p>
        <h4>সেবা পাবার শর্ত</h4>
        <h5>চেকআপ ব্যবহার করার আগে দয়া করে সেবা পাবার শর্তাদি পড়ুন। মনে রাখবেন, যে:</h5>
        <ul>
          <li>উপসর্গ চেকআপ রোগ নির্ণয় নয়। চেকআপ তথ্যগত উদ্দেশ্যে এবং এটি কোনও চিকিৎসার উপযুক্ত যোগ্যতাসম্পন্ন মতামত নয়।</li>
          <li>জরুরী পরিস্থিতিতে ব্যবহার করবেন না। স্বাস্থ্য জরুরী পরিস্থিতিতে অবিলম্বে আপনার স্থানীয় জরুরী নাম্বারে কল করুন।</li>
          <li>আপনার ডেটা নিরাপদ। আপনার সরবরাহ করা তথ্য বেনামে এবং কারও সাথে ভাগ করা যায় না।</li>
        </ul>
        
        <form>
          <fieldset class="form-group">
            <div class="custom-control custom-checkbox">
              <input id="checkCondition" type="checkbox" class="checkCondition custom-control-input">
              <label for="checkCondition" class="custom-control-label custom-checkbox mb-2 mr-sm-2 mb-sm-0">আমি সকল শর্তাবলী ও গোপনীয়তা নীতি পড়েছি এবং মেনে নিলাম</label>
            </div>
          </fieldset>
          </form>

         
        <p>প্রথম প্রশ্নে যাওয়ার জন্য দয়া করে <span class="badge badge-primary">পরবর্তী</span> বাটুন এ ক্লিক করুন।</p>
       
      </div>
    `);
  });
};

export default template;



// WEBPACK FOOTER //
// ./src/components/welcome/template.js